/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_IntroInputs */

const en_diff_intro = /** @type {(inputs: Diff_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two JSON documents structurally instead of as text. Each difference is reported with the exact path where it occurs, so you can see what changed without reading both files.`)
};

const ko_diff_intro = /** @type {(inputs: Diff_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 JSON 문서를 텍스트가 아니라 구조로 비교합니다. 각 차이는 발생한 정확한 경로와 함께 보고되므로, 두 파일을 다 읽지 않고도 무엇이 바뀌었는지 알 수 있습니다.`)
};

const ja_diff_intro = /** @type {(inputs: Diff_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つの JSON 文書をテキストではなく構造として比較します。各差分は発生した正確なパスとともに報告されるので、両方のファイルを読まずに何が変わったか分かります。`)
};

/**
* | output |
* | --- |
* | "Compare two JSON documents structurally instead of as text. Each difference is reported with the exact path where it occurs, so you can see what changed with..." |
*
* @param {Diff_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_intro = /** @type {((inputs?: Diff_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_intro(inputs)
	if (locale === "ko") return ko_diff_intro(inputs)
	return ja_diff_intro(inputs)
});